import { Component, OnInit } from '@angular/core';
import { AuthenticactionService } from 'src/app/_services/authentication.service';
import { SessionService } from 'src/app/_services/session.service';
import { AppConfig} from '../../app.config';
import { RouterModule, Router } from '@angular/router';
import {DocumentSigningService} from "../../_services/document-signing.service";
import {Location} from "@angular/common";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    private _externalUser = null;
    private _user = '';
    constructor(
        public config: AppConfig,
        public _sessionService: SessionService,
        public authService: AuthenticactionService,
        public router: Router,
        private documentSigningService: DocumentSigningService,
        private sessionService: SessionService,
        private location: Location
    ) { }

    async ngOnInit(): Promise<void> {
    }

    ngDoCheck(){
        if (this.externalUser === null) {
            this.externalUser = this.sessionService.getItem(AppConfig.CLERK_DATA);
            this.user = this.generateUserName(this.externalUser);
        }
    }

    public async logout(){
        await this.authService.logoutAll();
        await this.router.navigate(['']);
    }

    private generateUserName(userData){
        if (userData === null) {
            return ''
        } else {
            const name = userData['external_data']['name']['nombres'][0];
            const lastNames = userData['external_data']['name']['apellidos'].join(' ');
            return (name + ' ' + lastNames).toUpperCase();
        }
    }

    get externalUser(): any {
        return this._externalUser;
    }
    set externalUser(value: any) {
        this._externalUser = value;
    }
    get user() {
        return this._user;
    }
    set user(value) {
        this._user = value;
    }
}
